import {IToJson} from '@toolify/client/src/types/IToJson'
import {IAppEntityResponsePayload} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAppEntityResponsePayload'
import {mapFileVariantResponseInstance} from '@toolify/client/src/modules/api/singletons/mapFileVariantResponseInstance'

export function mapAppEntityResponsePayload(
  payload: IToJson<IAppEntityResponsePayload> | null | undefined,
): IAppEntityResponsePayload | null {
  if(!payload) {
    return null
  }
  return {
    ...payload,
    completedIconFileVariants: (payload.completedIconFileVariants || []).map(fileVariant => {
      return mapFileVariantResponseInstance(fileVariant)
    }),
  }
}
